// extracted by mini-css-extract-plugin
module.exports = {"usefulLink":"useful-links_usefulLink__2TQZz"};